import type { WatchlistSorting } from '../types';

type FieldInput = 'createdAt' | 'marketCap' | 'name' | 'discount';
type DirectionInput = 'ASC' | 'DESC';
type WatchlistItemSortingInput = {
  field: FieldInput;
  direction: DirectionInput;
};

export function watchlistSortingToQueryInput(
  sorting: WatchlistSorting
): WatchlistItemSortingInput {
  // '{field: name direction: DESC}' => 'field: name direction: DESC'
  const string = sorting.slice(1, sorting.length - 1);
  // 'field: name direction: DESC' => ['field', 'name', 'direction', 'DESC']
  const [_f, field, _d, direction] = string.split(' ');

  return {
    field: field as FieldInput,
    direction: direction as DirectionInput,
  };
}
